import { useGetCtaWrapperContent } from '@/vdp/CtaWrapper';
import { useIsCampaignTemplateOne } from '~/context/vdp/StaticContext';
import useAlertStatus from './useAlertStatus';

export default function useShowComposerPendingFooter() {
  const isCampaignTemplateOne = useIsCampaignTemplateOne();
  const { showCtaFooter } = useGetCtaWrapperContent();
  const { purchasePending } = useAlertStatus();

  return isCampaignTemplateOne && purchasePending && showCtaFooter;
}
